import React, { useMemo } from 'react';
import NotImplemented from '../NotImplemented';
import PageNotification from './PageNotification';
import safelyStringifyJSON from '../../utils/safelyStringifyJSON';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../utils/constants';
import { createObjectFromProps } from '../../utils/object';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1, variant2 } from './service/constants';
// @ts-ignore
const PageNotificationMap = ({ variant: propVariant, fields, rendering }) => {
    const appName = useAppName();
    let variant = '';
    let mappedFields = fields || {};
    switch (appName) {
        case HONDA_SITE_NAME:
            variant = variant1;
            break;
        case ACURA_SITE_NAME:
            variant = variant2;
            break;
        default:
            mappedFields = null;
            break;
    }
    const appNameConfig = useMemo(() => ({ variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant }), [propVariant, variant]);
    mappedFields = useMemo(() => createObjectFromProps(mappedFields), [safelyStringifyJSON(mappedFields)]);
    if (mappedFields === null) {
        return React.createElement(NotImplemented, { name: "PageNotification" });
    }
    return (React.createElement(PageNotification, { appNameConfig: appNameConfig, componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, fields: mappedFields }));
};
export default PageNotificationMap;
